import en from "./en.js";
import hi from "./hi.js";

export default {
  en,
  hi,
};
